import * as twgl from "twgl.js";

export type VertexBufferData = number[] | Float32Array;

export function createTriangleBuffer(gl: WebGL2RenderingContext, vertices: VertexBufferData): twgl.BufferInfo {
  return twgl.createBufferInfoFromArrays(gl, {
    position: {
      numComponents: 2,
      data: vertices,
    },
  });
}

export function createTexturedQuadBuffer(gl: WebGL2RenderingContext, vertices: VertexBufferData): twgl.BufferInfo {
  return twgl.createBufferInfoFromArrays(gl, {
    position: {
      numComponents: 2,
      data: vertices,
    },
    texcoord: {
      numComponents: 2,
      data: [0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1],
    },
  });
}
